import { CacheProvider } from '@emotion/react'
import React, { useMemo } from "react"
import { createPortal } from "react-dom"
import createCache from "@emotion/cache"
import { ThemeProvider, useTheme } from '@mui/material'

const WebinarPipPortal = ( { children, pipWindow, onClose } ) => {

    const outerTheme = useTheme()

    const pipCache = useMemo( () => {
        if ( !pipWindow?.document ) return null

        return createCache( {
            key: "pip-css",
            // Inject styles into the PiP window's head
            container: pipWindow.document.head,
            // Styles are prepended so they don't break order
            prepend: true,
        } )
    }, [pipWindow] )

    const pipTheme = useMemo( () => {
        return {
            ...outerTheme,
            components: {
                ...outerTheme.components,
                MuiUseMediaQuery: {
                    defaultProps: {
                        // This tells MUI hooks to look at the PiP window's dimensions
                        // instead of the main browser window.
                        node: pipWindow,
                    },
                },
            },
        }
    }, [outerTheme, pipWindow] )

    const content = pipCache ? (
        <CacheProvider value={pipCache}>
            <ThemeProvider theme={pipTheme}>
                {children}
            </ThemeProvider>
        </CacheProvider>
    ) : (
        children
    )

    return createPortal( content, pipWindow.document.body )
}

export default WebinarPipPortal